import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
// DEC-1146: install the global error listeners BEFORE the first render, so an
// error thrown during the initial mount is captured too — that is exactly the
// class of failure a user cannot describe and most needs us to have recorded.
import { installErrorListeners } from './services/errorBuffer';

installErrorListeners();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker for PWA — production only.
// In development the SW caches the JS bundle and routinely serves stale
// code after refactors. Localhost dev should always hit the network.
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then((registration) => {
        console.log('SW registered:', registration);
      })
      .catch((error) => {
        console.log('SW registration failed:', error);
      });
  });
} else if ('serviceWorker' in navigator) {
  // In dev, proactively unregister any SW left over from a prior build —
  // belt-and-suspenders so devs don't get bitten by cached bundles even
  // once the production-only gate above is in place.
  navigator.serviceWorker.getRegistrations()
    .then(regs => regs.forEach(reg => reg.unregister()))
    .catch(() => { /* no-op */ });
}
